var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.componentKey,staticClass:"container-fluid mt-2"},[(!_vm.currentIncidentId)?[_c('past-incident')]:_vm._e(),(_vm.currentIncidentId)?[_c('conversation',{attrs:{"incidentId":_vm.currentIncidentId}})]:_vm._e(),_c('prompt-user',{attrs:{"openModal":_vm.openUserModal},on:{"closeMe":_vm.closeNewUser}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }